import { useTranslation } from 'next-i18next';
import React, { PropsWithChildren, ReactElement } from 'react';
import { Container } from 'components/domain/container';
import {
  GridRecommendationBlock,
  GridRecommendationSectionMainTitle,
} from './CommonGridRecommendationSection.styles';
import { LoadMoreButtonWithWrapper } from './LoadMoreButton';
import { recommendationsLoadMoreTracking } from './recommendationsTracking';

interface ICommonGridRecommendationSectionProps {
  nextPage(): void;
  hasMore: boolean;
  loading?: boolean;
  id?: string;
  mainTitle?: string;
  loadMoreText?: string;
  fontColor?: string;
  bgColor?: string;
  testId?: string;
}

function CommonGridRecommendationSection(
  props: PropsWithChildren<ICommonGridRecommendationSectionProps>
): ReactElement {
  const {
    nextPage,
    hasMore,
    loading,
    id,
    mainTitle,
    loadMoreText,
    fontColor,
    bgColor,
    testId,
    children,
  } = props;
  const [t, { language }] = useTranslation('common');

  return (
    <GridRecommendationBlock
      fontColor={fontColor}
      bgColor={bgColor}
      data-id={testId}
      className="geo-recommender"
      id={id}
    >
      <Container>
        <GridRecommendationSectionMainTitle
          dangerouslySetInnerHTML={{ __html: mainTitle }}
        />
        {children}
        {hasMore && !loading ? (
          <LoadMoreButtonWithWrapper
            onClick={() => {
              nextPage();
              recommendationsLoadMoreTracking(language);
            }}
          >
            {loadMoreText ? loadMoreText : t('common:load.more')}
          </LoadMoreButtonWithWrapper>
        ) : null}
      </Container>
    </GridRecommendationBlock>
  );
}

export default CommonGridRecommendationSection;
